import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
};

var slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;

        try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);

                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }

        return _arr;
    }

    return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var useJitsi = function useJitsi(options) {
    var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'meet.jit.si';

    var _useState = useState(null),
        _useState2 = slicedToArray(_useState, 2),
        jitsi = _useState2[0],
        setJitsi = _useState2[1];

    useEffect(function () {
        if (window.JitsiMeetExternalAPI) {
            options.parentNode = document.getElementById(options.parentNode);
            //console.log("Your role is :");
            //console.log(options.role);
            options.configOverwrite = {
                startAudioOnly: (options.role == "student") ? false : false,
                enableNoisyMicDetection: true,
                startAudioMuted: 1,
                startVideoMuted: 1,
                disableSimulcast: false,
                liveStreamingEnabled: false,
                autoCaptionOnRecord: false,
                enableWelcomePage: false,
                enableClosePage: false,
                enableCalendarIntegration: false,
                prejoinPageEnabled: false,
                gatherStats: false,
                doNotStoreRoom: true,
                resolution: 720,
                //maxFps: 15,
                constraints: {
                    video: {
                        //aspectRatio: 16 / 9,
                        height: {
                            ideal: 720,
                            max: 720,
                            min: 180
                        },
                        /*
                        frameRate: {
                            max: 15
                        }*/
                    }
                },
                localRecording: {
                    enabled: false,
                    format: 'ogg'
                },
                remoteVideoMenu: {
                    //     // If set to true the 'Kick out' button will be disabled.
                    disableKick: (options.role == "student") ? true : false,
                },

                // If set to true all muting operations of remote participants will be disabled.
                disableRemoteMute: (options.role == "student") ? true : false,

            };


            options.interfaceConfigOverwrite = {
                TOOLBAR_BUTTONS: [
                    'microphone', 'camera', 'closedcaptions', 'desktop',
                    'fodeviceselection', 'hangup', 'chat',
                    'etherpad', 'raisehand', 'videoquality', 'filmstrip',
                    'mute-everyone', 'fullscreen'
                ],
                DEFAULT_LOGO_URL: 'http://esst.in/olc/services/assets/uploads/files/e6bffbf9401f436799b098f92e0adfad_ES.png',
                DEFAULT_REMOTE_DISPLAY_NAME: options.displayName,
                DEFAULT_LOCAL_DISPLAY_NAME: 'My Screen',
                SHOW_JITSI_WATERMARK: false,
                HIDE_KICK_BUTTON_FOR_GUESTS: true,
                BRAND_WATERMARK_LINK: '',
                JITSI_WATERMARK_LINK: 'http://esst.in/',
                SHOW_WATERMARK_FOR_GUESTS: false,
                CLOSE_PAGE_GUEST_HINT: false,
                SHOW_PROMOTIONAL_CLOSE_PAGE: false,
                CONNECTION_INDICATOR_DISABLED: false,
                RECENT_LIST_ENABLED: false,
                SHOW_CHROME_EXTENSION_BANNER: false,
                SHOW_BRAND_WATERMARK: false,
                APP_NAME: 'Live Class',
                NATIVE_APP_NAME: 'Live Class',
                PROVIDER_NAME: 'Easysoft',
                MOBILE_APP_PROMO: false,
                APP_SCHEME: 'org.easysoft.onlineclasses',
                ANDROID_APP_PACKAGE: 'org.easysoft.onlineclasses',
                MOBILE_DOWNLOAD_LINK_ANDROID: 'https://play.google.com/store/apps/details?id=org.easysoft.onlineclasses',
            };
            options.userInfo = {
                displayName: options.displayName
            }
            // eslint-disable-next-line no-undef
            setJitsi(new JitsiMeetExternalAPI(domain, options));
        } else {
            setJitsi({ error: 'JitsiMeetExternalAPI is not available, check if https://meet.jit.si/external_api.js was loaded' });
        }
        return function () {
            return jitsi && jitsi.dispose();
        };
    }, []);

    return jitsi;
};

useJitsi.propTypes = {
    options: PropTypes.shape({
        roomName: PropTypes.string.isRequired,
        width: PropTypes.string,
        height: PropTypes.string,
        parentNode: PropTypes.string,
        configOverwrite: PropTypes.string,
        interfaceConfigOverwrite: PropTypes.object,
        noSSL: PropTypes.bool,
        jwt: PropTypes.string,
        onload: PropTypes.func,
        invitees: PropTypes.array,
        devices: PropTypes.object,
        userInfo: PropTypes.object,
        role: PropTypes.string
    }),
    domain: PropTypes.string
};

var Jutsu = function Jutsu(props) {
    var domain = props.domain,
        roomName = props.roomName,
        displayName = props.displayName,
        password = props.password,
        role = props.role,
        _props$jwt = props.jwt,
        jwt = _props$jwt === undefined ? null : _props$jwt,
        subject = props.subject;
    var loadingComponent = props.loadingComponent,
        containerStyles = props.containerStyles,
        jitsiContainerStyles = props.jitsiContainerStyles;

    var _useState = useState(true),
        _useState2 = slicedToArray(_useState, 2),
        loading = _useState2[0],
        setLoading = _useState2[1];

    var jitsi = useJitsi({ roomName: roomName, displayName: props.displayName, parentNode: 'jitsi-container', jwt: jwt }, domain);

    var containerStyle = {
        width: '800px',
        height: '400px'
    };

    var jitsiContainerStyle = {
        display: loading ? 'none' : 'block',
        width: '100%',
        height: '100%'
    };

    useEffect(function () {
        if (jitsi) {
            jitsi.executeCommand('subject', subject);

            jitsi.addEventListener('videoConferenceJoined', function () {
                //if (password) jitsi.executeCommand('password', password);
                setLoading(false);
                jitsi.executeCommand('displayName', displayName);
            });

            jitsi.addEventListener('passwordRequired', function () {
                if (password) {
                    jitsi.executeCommand('password', password);
                }
                setLoading(false);
            });
        }

        return function () {
            return jitsi && jitsi.dispose();
        };
    }, [jitsi]);

    return React.createElement(
        'div',
        { style: _extends({}, containerStyle, containerStyles) },
        loading && (loadingComponent || React.createElement(
            'p',
            null,
            'Loading ...'
        )),
        React.createElement('div', {
            id: 'jitsi-container',
            style: _extends({}, jitsiContainerStyle, jitsiContainerStyles)
        })
    );
};

Jutsu.propTypes = {
    domain: PropTypes.string,
    roomName: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    password: PropTypes.string,
    jwt: PropTypes.string,
    subject: PropTypes.string,
    loadingComponent: PropTypes.object,
    containerStyles: PropTypes.object,
    jitsiContainerStyles: PropTypes.object
};

export { Jutsu, useJitsi };
//# sourceMappingURL=index.es.js.map
